import { Api } from "./Api";
require('dotenv');
const axios = require('axios').default;

let MessageApi = {

    endpoint : "Messages/",

    async add(item) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;

        const response = await axios.post(URL, item, { withCredentials: true });
        return response.data;
    }
}

//Add the Api Mixin
MessageApi = Object.assign({}, Api, MessageApi);

export { MessageApi };
